import { render, staticRenderFns } from "./list_category.vue?vue&type=template&id=20e44e39&scoped=true"
import script from "./list_category.vue?vue&type=script&lang=js"
export * from "./list_category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e44e39",
  null
  
)

export default component.exports